import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';

import { SelectOpenContext, SelectSearchContext } from './context';

function Select({
  searchable = false,
  children,
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Root> & {
  searchable?: boolean;
}) {
  const [searchValue, setSearchValue] = React.useState('');
  const [isOpen, setIsOpen] = React.useState(false);

  // Reset search when select closes
  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      setIsOpen(open);
      if (!open) {
        setSearchValue('');
      }
      props.onOpenChange?.(open);
    },
    [props],
  );

  const searchContextValue = React.useMemo(
    () => ({ searchValue, setSearchValue }),
    [searchValue],
  );

  const openContextValue = React.useMemo(() => ({ isOpen }), [isOpen]);

  const content = (
    <SelectOpenContext.Provider value={openContextValue}>
      <SelectPrimitive.Root
        data-slot="select"
        {...props}
        onOpenChange={handleOpenChange}
      >
        {children}
      </SelectPrimitive.Root>
    </SelectOpenContext.Provider>
  );

  if (searchable) {
    return (
      <SelectSearchContext.Provider value={searchContextValue}>
        {content}
      </SelectSearchContext.Provider>
    );
  }

  return content;
}

function SelectGroup({
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Group>) {
  return <SelectPrimitive.Group data-slot="select-group" {...props} />;
}

function SelectValue({
  ...props
}: React.ComponentProps<typeof SelectPrimitive.Value>) {
  return <SelectPrimitive.Value data-slot="select-value" {...props} />;
}

export { Select, SelectGroup, SelectValue };
